import { EditorID } from 'Cloud/Application/Editor/types';

export const availableEditors = [
    EditorID.MAILPAD,
    EditorID.R7,
    EditorID.MYOFFICE,
    EditorID.DOCS_MAIL,
    EditorID.OVIDIUS_V2,
    EditorID.R7_WOPI,
];
